import axios from 'axios'
export default async (username) => {
    let backend= "https://api-dashboard.oned.io"
    let backend2= "http://localhost:3000"
    
    let return_value=await axios.get(`${backend}/login/getProfilePhoto/${username}`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      })
      return return_value
}